export enum AppModule {
  DemandForecast = "DEMAND_FORECAST",
  AllocationCheckList = "ALLOCATION_CHECK_LIST",
  UsageForecast = "USAGE_FORECAST",
  RetinaForecast = "RETINA_FORECAST",
}

export const ALL_APP_MODULES: AppModule[] = [
  AppModule.DemandForecast,
  AppModule.AllocationCheckList,
  AppModule.UsageForecast,
  AppModule.RetinaForecast,
];
